import * as React from 'react'

import { inject, observer } from 'mobx-react'

import { authLinkClassName } from '~/client/src/shared/components/AuthLayout'
import { buttonVariants } from '~/client/src/shared/components/Button/Button'
import InitialState from '~/client/src/shared/stores/InitialState'
import { cn } from '~/client/src/shared/utils/cn'

interface IProps {
  mailto: string
  hint: string
  subject?: string
  state?: InitialState
}

// Support filters mail by project through plus-addressing: info+<project>@…
export function getSupportEmail(mailto: string, projectName?: string): string {
  if (!projectName) {
    return mailto
  }

  const [localPart, domain] = mailto.split('@')
  return `${localPart}+${projectName}@${domain}`
    .replace(/\s/g, '_')
    .toLocaleLowerCase()
}

function ContactHelp({ mailto, hint, subject, state }: IProps) {
  const email = getSupportEmail(mailto, state?.activeProject?.name)
  const query = subject ? `?subject=${encodeURIComponent(subject)}` : ''

  return (
    <a
      className={cn(buttonVariants({ variant: 'link' }), authLinkClassName)}
      href={`mailto:${email}${query}`}
    >
      {hint}
    </a>
  )
}

export default inject('state')(observer(ContactHelp))
